<script lang="ts">
    import { RadioGroup } from 'bits-ui';
    import { t } from 'svelte-i18n';
    import ProductDetailsTab from '$lib/components/productDetails/ProductDetailsTab.svelte';
    import type { ApiSchemas } from '$lib/api/shopwareApi.js';
    import { usePropertiesContext } from '$lib/context.js';

    const properties = usePropertiesContext();

    export let product: ApiSchemas['Product'];
    export let optionGroups;
    export let beverageCategory: string;

    $: type = product.properties.find((property: { groupId: string }) => property.groupId === properties.type.id);
    $: taste = product.properties.find((property: { groupId: string }) => property.groupId === properties.taste.id);

    let currentTab: string | undefined;
    let tabs: { id: string; active: boolean }[];

    $: if (product) {
        tabs = [
            {
                id: 'details',
                active: beverageCategory !== 'Ticket' && beverageCategory !== 'Paket'
            },
            {
                id: 'description',
                active: !!product.translated?.description
            },
            {
                id: 'nutrition-table',
                active: !!product.translated?.customFields?.custom_lewo_erp_nutrition_table
            }
        ];
    }

    $: if (product && (!currentTab || !tabs.find((tab) => tab.id === currentTab && tab.active))) {
        currentTab = tabs.find((tab) => tab.active)?.id;
    }
</script>

{#if currentTab}
    <section>
        <RadioGroup.Root
            bind:value={currentTab}
            class="*:uppercase mb-6 border-b font-medium border-primary flex flex-row gap-x-10 sm:gap-x-14 text-primary/50 text-sm *:py-3 overflow-hidden hide-scrollbar tracking-[0.08em]"
        >
            {#each tabs as tab}
                {#if tab.active}
                    <RadioGroup.Item
                        class="data-[state=checked]:text-primary transition-colors hover:sm:text-primary text-left"
                        value={tab.id}
                    >
                        {$t(`shop.product.${tab.id}`)}
                    </RadioGroup.Item>
                {/if}
            {/each}
        </RadioGroup.Root>
        <div class="text-base-300 tracking-normal max-h-[15rem] lg:max-h-[11.25rem] overflow-y-auto">
            {#if currentTab === 'details'}
                <ProductDetailsTab {optionGroups} {product} {type} {taste} />
            {:else if currentTab === 'description'}
                <p>
                    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
                    {@html product.translated?.description ?? ''}
                </p>
            {:else if currentTab === 'nutrition-table'}
                <iframe
                    title="e-label"
                    class="w-full"
                    src={product.translated.customFields.custom_lewo_erp_nutrition_table}
                />
            {/if}
        </div>
    </section>
{/if}
